export enum AppFrontendRoute {
    Assets = 'assets/',
    Connections = 'connections/',
    Dashboard = 'dashboard/',
    DashboardBrands = 'dashboard/brands/',
    Logout = 'logout/',
    ManageTemplates = 'manage/templates/',
    ManageTemplatesEmail = 'manage/templates/email/',
    ManageTemplatesMedia = 'manage/templates/media/',
    PublishEmail = 'publish/email/',
    PublishEmailBuild = 'publish/email/build/',
    PublishEmailConfirmation = 'publish/email/confirmation/',
    PublishEmailPreview = 'publish/email/preview/',
    PublishEmailSchedule = 'publish/email/schedule/',
    PublishMedia = 'publish/media/',
    PublishMediaBuild = 'publish/media/build/',
    PublishMediaPreview = 'publish/media/preview/',
    PublishMediaSchedule = 'publish/media/schedule/',
    ReportsTemplates = 'reports/templates/',
    Scheduled = 'scheduled/',
    Templates = 'templates/',
}
